import $ from 'jquery';

$(document).on('click', '.navigation-menu-trigger', (event) => {
  vueStore.commit('openSidebar', 'navigation');

  event.preventDefault();
});
